/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import actionTypes from './Personalization-ActionTypes';

const updatePersonalization = (cart) => ({
    type: actionTypes.UPDATE_PERSONALIZATION,
    data: cart,
});

export default updatePersonalization;
